import React from 'react';
/**
 * @jest-environment jsdom
 */

import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from 'jl-design-system/elements/button/Button';
import CrossRegular from 'jl-design-system/elements/icons/CrossRegular';
import styles from './FlyoutMenu.scss';

const CloseButton = ({ onClose }) => (
  <Button
    className={classNames(styles.close)}
    onClick={onClose}
    data-testid="nav-close-button"
  >
    <CrossRegular box />
    <span className={styles.visuallyHidden}>Close</span>
  </Button>
);

CloseButton.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default CloseButton;
